import { render, staticRenderFns } from "./DeliveryConfirmation.vue?vue&type=template&id=799650ca&scoped=true"
import script from "./DeliveryConfirmation.vue?vue&type=script&lang=ts"
export * from "./DeliveryConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryConfirmation.vue?vue&type=style&index=0&id=799650ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799650ca",
  null
  
)

export default component.exports